import CustomCategory from "../../../model/packageDelivery/customCategory/CustomCategory";
import CommonStore from "../../../stores/CommonStore";
import {action, makeAutoObservable} from "mobx";
import {CustomCategoryService} from "../../../service/packageDelivery/customCategory/CustomCategoryService";

const ERROR_MAP = {
    unauthorized: ["ERROR_00_401_00"]
}
class RemoveCustomCategoryButtonStore{

    public customCategory:CustomCategory
    public loading: boolean
    public commonStore: CommonStore

    constructor(commonStore: CommonStore, customCategory: CustomCategory) {
        this.customCategory = customCategory;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async remove() {
        const response = await CustomCategoryService.remove(this.customCategory);
        this.commonStore.processErrors(response);
        this.processError(response.error)
        return response.success;
    }

    processError(error?: string) {
        if (error) {
            if (ERROR_MAP.unauthorized.includes(error)) {
                this.commonStore.showErrorToast(error) //DONT SHOW THE TOAST BECAUSE IT TRGGERS THE SEACH AGAIN OR DO THE LOGOUT
            }
        }
    }
}
export default RemoveCustomCategoryButtonStore